import { fromJS } from 'immutable'
export default fromJS({
  upload: { selectFile: 'Sélectionner un document...' },
  form: { name: 'Nom: ${name}' },
  shared: {
    components: {
      form: {
        businessPlaceInput: {
          moreNearbyResults: "Afficher d'autres magasins à proximité",
          error: { couldNotFindNearbyResults: "Aucun résultat n'a pu être trouvé à proximité d'un lieu particulier" },
          noResultsMessage: 'Aucun résultat trouvé.',
          chosen: 'Site sélectionné',
          label: 'Chercher un nom ou une adresse',
          choose: 'Veuillez sélectionner',
          orClickOnMap: '... ou cliquez sur la carte',
          currentMarkerSelection: 'Lois marquage',
          nearby: 'À proximité',
        },
      },
    },
  },
  error: { network: "La connexion au serveur n'a pas pu être établie" },
  names: { lastName: 'Nom', firstName: 'Prénom' },
  errors: {
    acceptance: "S'il-vous-plaît acceptez.",
    default: 'Veuillez remplir ce champ',
    canNotConnectToServer: 'Pour le moment le serveur ne peut pas être atteint',
    iban: 'Veuillez indiquer un IBAN valide',
    fileTooBig: 'Taille de fichier ${name} trop grande pour le upload',
    uploadBlocked: "Un document a été bloqué ou n'a pas pu être traité",
    time: "Veuillez indiquer un format d'heure valide",
    phone: 'Veuillez indiquer un numéro de téléphone valable.',
    date: 'Veuillez indiquer une date valide',
    fileTooSmall: 'Taille de fichier trop petite pour ${name}',
    currency: 'Veuillez indiquer un montant valide',
    file: 'Veuillez sélectionner un fichier',
    email: 'Veuillez indiquer une adresse e-mail valable.',
    boundaryError: "Une erreur s'est produit",
    inputContainsBinRange: 'Ne nous communiquez pas votre numéro de carte de crédit',
  },
  genders: { female: 'Madame', male: 'Monsieur' },
  button: { send: 'Envoyer', delete: 'Supprimer' },
  address: { city: 'Lieu', zip: 'NPA', street: 'Rue' },
  confirmation: { backHome: "Retour vers la page d'accueil" },
  not_found: { title: "Le formulaire n'a pas été trouvé" },
  format: { time: 'HH:MM', date: 'JJ.MM.AAAA' },
  loading: { title: 'Chargement...' },
})
